/* eslint no-unused-expressions: 0 */

import styled from 'styled-components';

export const H1 = styled.div`
  color: ${({ theme }) => theme.palette.greyScaleDeprecated[1]};
  font-size: 12px;
  font-weight: 500;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 100%;
`;

export const H2 = styled.div`
  color: ${({ theme }) => theme.palette.greyScaleDeprecated[2]};
  font-size: 12px;
  width: 100%;
`;
